import { LAYOUT } from '@/router/constant';
import type { AppRouteModule } from '@/router/types';
import { PageEnum } from '@/enums/pageEnum';
import { t } from '@/hooks/web/useI18n';

const Home: AppRouteModule = {
    path: '/home',
    name: 'Home',
    component: LAYOUT,
    redirect: '/home/display',
    meta: {
        orderNo: '10',
        icon: 'home',
        title: t('routes.index.home'),
    },
    children: [
        {
            path: 'display',
            name: 'Display',
            component: () => import('@/views/home/display.vue'),
            meta: {
                title: t('routes.index.home'),
            },
        },
        {
            path: 'game-record',
            name: PageEnum.RECORD_INDEX,
            component: () => import('@/views/main/game-record/game-record.vue'),
            meta: {
                title: t('routes.index.gameRecord.gameRecord'),
            },
            children: [
                {
                    path: 'review',
                    name: PageEnum.REVIEW,
                    component: () => import('@/views/main/game-record/review/review.vue'),
                    meta: {
                        title: t('routes.index.gameRecord.review'),
                    },
                },
                {
                    path: 'mistake',
                    name: PageEnum.MISTAKE,
                    component: () => import('@/views/main/game-record/review/mistake.vue'),
                    meta: { title: t('routes.index.gameRecord.mistake') },
                },
                {
                    path: 'payment',
                    name: PageEnum.REVIEW_PAYMENT,
                    component: () => import('@/views/main/game-record/review/payment.vue'),
                    meta: { title: t('routes.index.gameRecord.payment') }
                }
            ],
        },
        {
            path: 'news',
            name: PageEnum.NEWS,
            component: () => import('@/views/main/news/news.vue'),
            meta: {
                title: t('routes.index.news'),
            },
            children: [],
        },
        {
            path: 'cy',
            name: PageEnum.CY,
            component: () => import('@/views/main/cy/index.vue'),
            meta: {
                title: t('routes.index.cy.cy'),
            },
        },
        {
            path: 'cy-buy',
            name: PageEnum.CY_BUY,
            component: () => import('@/views/main/cy/buy.vue'),
            meta: {
                title: t('routes.index.cy.buy'),
            },
        },
        {
            path: 'score',
            name: PageEnum.SCORE,
            component: () => import('@/views/main/score/index.vue'),
            meta: {
                title: t('routes.index.score'),
            },
        },
    ],
};

export default Home;
